import { RestClient } from '@/api/rest-client'
import { Status } from '@/api/model/status'
import { Company } from '@/api/model/company'
import { cloneDeep } from 'lodash'

export class StatusClient extends RestClient<Status> {
    collectionName = 'statuses'
    parseData = Status.fromData

    async create(data: Status): Promise<Status> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: Status): Promise<Status> {
        const request = cloneDeep<any>(data)

        if (data.company) {
            delete request.company
        }

        return super.update(id, request)
    }

    protected handleError(error: any) {
        throw error
    }
}
